module.exports = __webpack_public_path__ + "static/img/13.c615d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solu/13.png
// module id = jozA
// module chunks = 0